export const allMenuItems = [
  {
    id: 1,
    href: "customer/home",
    nombre: "Inicio",
    icon: "fas fa-home",
    subMenus: [],
  },

  {
    id: 2,
    href: "estadisticas",
    nombre: "Estadísticas",
    icon: "fas fa-user-tie",
    subMenus: [],
  },
  {
    id: 3,
    href: "pedidos",
    nombre: "Pedidos",
    icon: "fas fa-cart-shopping",
    subMenus: [],
  },
  {
    id: 4,
    href: "ordenes-trabajo",
    nombre: "Ordenes de Trabajo",
    icon: "fas fa-screwdriver-wrench",
    subMenus: [],
  },
];
